export default class Utility {

  static isLocalURL(): boolean {
    return window.location.hostname.includes('itt.dev.com');
  }
}